import getTextWidth from './getTextWidth'
import { MULTIPLY_WIDTH } from '.'

function getColumnTitleWidth(title: string, fixed = false) {
  return getTextWidth(title) + 4 + (fixed ? 10 : 60) * MULTIPLY_WIDTH
}

export default getColumnTitleWidth
